import { DatePicker } from 'antd'
import { DispositionSelector } from '../DispositionSelector'
import { CommentFormItem } from '../CommentFormItem'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'
import CIMSSelect from 'components/CIMSSelect'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import ExternalLinkEditor from 'components/ExternalLinkEditor'
import { RouterActionsProps } from './types'
import { useWatch } from 'antd/lib/form/Form'
import { useEffect, useState } from 'react'
import { useRequireCommentByDisposition } from '../../hooks/useRequireCommentByDisposition'

export const RouterActions: React.VFC<RouterActionsProps> = ({ form }) => {
  const [actionOptions] = useState([
    {
      label: 'Route to Group Review',
      value: 'route',
      commentAction: 'routing',
    },
    {
      label: 'Route to Resident Engineer Review',
      value: 'groupReviewAsRouter',
      commentAction: 'routing',
    },
    {
      label: 'Submit Disposition as Router',
      value: 'reReviewAsRouter',
      commentAction: 'disposition',
    },
    {
      label: 'Request Revisions',
      value: 'requestRevisions',
      commentAction: 'review',
    },
  ])
  const {
    selectOptions: { routingGroupOptions },
    quickLinks,
    metaFetching,
  } = useSubmittalTrackerContext()
  const help = HelpMessage.CAS.SubmittalTracker
  const { required } = useRequireCommentByDisposition(form)
  const action = useWatch('action', form)
  const [commentAction, setCommentAction] =
    useState<(typeof actionOptions)[number]['commentAction']>('')
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setCommentAction(
      actionOptions.find(({ value }) => value === action)?.commentAction ?? ''
    )
  }, [action, form, actionOptions])
  return (
    <>
      <CIMSFormItem
        name="action"
        label="Action"
        requiredMessage="Please select an action"
      >
        <CIMSSelect simple options={actionOptions} />
      </CIMSFormItem>
      {action && (
        <>
          {action !== 'requestRevisions' && (
            <CIMSFormItem
              name="contractualReviewDate"
              label="Contractual Review Date"
              requiredMessage="Please enter a contractual review date"
              help={help.ContractualReviewDate}
            >
              <DatePicker />
            </CIMSFormItem>
          )}
          {action === 'route' && (
            <CIMSFormItem
              name="routingGroups"
              label="Routing Groups"
              requiredMessage="Please select at least one routing group"
              help={help.RoutingGroups}
            >
              <CIMSSelect mode="multiple" options={routingGroupOptions} />
            </CIMSFormItem>
          )}
          {action === 'reReviewAsRouter' && <DispositionSelector />}
          <CommentFormItem
            required={required ? { action: commentAction } : false}
          />
          {action !== 'requestRevisions' && action !== 'reReviewAsRouter' && (
            <ExternalLinkEditor
              quickLinkOptions={{ quickLinks, loading: metaFetching }}
            />
          )}
        </>
      )}
    </>
  )
}
